import { connect } from 'react-redux';
import { VideoSelfie } from './Videoselfie';
import { actions } from 'react-redux-form';
const { setValidity, change } = actions;
import { identifyVideo } from 'actions/identify';
import { showPreLoader, hidePreLoader } from 'actions/preLoaderActions';
import { loanStatus, loanIdentification } from 'actions/aresActions';
import { showModalCancel } from 'actions/modalCancelActions';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        options: state.options,
    };
};

const mapDispatchToProps = {
    identifyVideo,
    showModalCancel,
    setValidity,
    change,
    loanStatus,
    showPreLoader,
    hidePreLoader,
    loanIdentification,
};

export const VideoSelfieContainer = connect(mapStateToProps, mapDispatchToProps)(VideoSelfie);
